import React, { useEffect, useState } from "react";
import { PiGitPullRequestDuotone } from "react-icons/pi";
import LeaveApplicationPopup from "./LeaveApplicationPopup";
import { AiOutlineNodeExpand } from "react-icons/ai";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import { Link } from "react-router-dom";
import { GrView } from "react-icons/gr";
import { FaRegEdit } from "react-icons/fa";
import { MdAssignmentAdd } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa6";
import { FallingLines } from "react-loader-spinner";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { FaSearch } from 'react-icons/fa';


const LeaveApplication = () => {

  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

  const [Open, setOpen] = useState(false);
  const [data, setData] = useState();
  const [searchdata, setSearchData] = useState();
  const [loader, setLoader] = useState(true);
  const [Division, setDivision] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [grade, setGrade] = useState(false);
  const [selectedgrade, setSelectedGrade] = useState(false);
  const [jobtitle, setJobTitle] = useState(null);
  const [selectedJob, setSelectedJobTitle] = useState(null);
  const [reset, setReset] = useState(false);
  const [empPopup, setEmpIdPopup] = useState(false);
  const [resetalldata, setResetallData] = useState(false);
  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
          searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${
          selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`
      );
      if (response?.data) {
        setData(response.data);

        setReset(false);
      }
    };
    if (reset) {
      getData();
    }
  }, [reset]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
      );
      if (response?.data) {
        setData(response.data);
        setSearchData("");
        setSelectedJobTitle("");
        setSelectedDivision("");
        setSelectedGrade("");
        setResetallData(false);
      }
    };
    if (resetalldata === true || selectedJob === '' && selectedDivision === '' && selectedgrade === '') {
      getData();
      console.log("Reset All Data");
    }
  }, [resetalldata,selectedDivision,selectedJob,selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
            searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${
            selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        }
      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, [selectedDivision,selectedJob,selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);
        }
      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getSearch = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/FREETEXT/YES/${
          searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${
          selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (searchdata) {
      setTimeout(() => {
        getSearch();
      }, 10);
    } else {
      const getData = async () => {
        try {
          const response = await axios.get(
            `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
              searchdata ? searchdata : "ALL"
            }/${selectedJob ? selectedJob : "ALL"}/${
              selectedgrade ? selectedgrade : "ALL"
            }/${selectedDivision ? selectedDivision : "ALL"}`
          );
          if (response?.data) {
            setData(response.data);
          }
        } catch (error) {
          console.error('PersonalInfoListEerror:', error);
        }
      };

      getData();
    }
  }, [searchdata]);

  useEffect(() => {
    const getFilteredData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
          searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${
          selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedJob) {
      console.log(selectedJob,'selectedJob')
      getFilteredData();
    } else if(selectedJob === '' && selectedDivision === '' && selectedgrade === ''){
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedJob]);

  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
          searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${
          selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedDivision) {
      console.log(selectedDivision,'selectedDivision')
      console.log((typeof(selectedDivision)),'selectedDivisionType')
      getFilteredData();
    } else if(selectedJob === '' && selectedDivision === '' && selectedgrade === ''){
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedDivision]);

  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${
          searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${
          selectedgrade !== "Grade" ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedgrade) {
      console.log(selectedgrade,'selectedgrade')
      getFilteredData();
    }  else if(selectedJob === '' && selectedDivision === '' && selectedgrade === ''){
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedgrade);
  }, [selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`
      );
      if (response?.data) {
        setDivision(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MasterList/${companyCode}/JOBTITLE/-`
      );
      if (response?.data) {
        setJobTitle(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`
      );
      if (response?.data) {
        setGrade(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (searchdata && data === null) {
      setLoader(true);
    } else if (searchdata && data) {
      setLoader(false);
    } else if (data) {
      setLoader(false);
    }
  }, [searchdata, data]);

  return (
    <div>
      <div className={"leave-allotment container-fluid"}>
        <div className=" flex justify-between items-center  mb-4">
            <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">
              Leave Application</h6>
            <div className="row">
            <div className="col-6 col-lg-3 mb-2">


            <div className="EmpList-search-container">
                <FaSearch className="EmpList-search-icon" />
                <input type="text" placeholder="Search" className="EmpList-search-input bg-transparent"
                  onChange={(e) => setSearchData(e.target.value)}
                />
            </div>

              {/* <input
                type="text"
                value={searchdata}
                className="form-control"
                placeholder="Search Here"
                onChange={(e) => setSearchData(e.target.value)}
              /> */}
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <select
                class="form-select DropNewUI"
                onChange={(e) => setSelectedJobTitle(decodeURI(e.target.value))}
                value={selectedJob}
                aria-label="Default select example"
                placeholder="Select Job Title"
              >
                <option
                  value=""
                  selected
                  onClick={() => setSelectedJobTitle(null)}
                >
                  Job Title
                </option>
                {jobtitle
                  ? jobtitle?.map((d, i) => (
                      <>
                        <option
                          value={d.Description}
                          onClick={(e) => setSelectedJobTitle(e.target.value)}
                        >
                          {d.Description}
                        </option>{" "}
                      </>
                    ))
                  : null}
              </select>
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <select
                value={selectedgrade}
                class="form-select DropNewUI"
                onChange={(e) => setSelectedGrade(e.target.value)}
                aria-label="Default select example"
                placeholder="Select Job Title"
              >
                <option
                  value=""
                  selected
                  onClick={() => setSelectedGrade(null)}
                >
                  Grade
                </option>
                {grade
                  ? grade?.map((d, i) => (
                      <>
                        <option
                          value={d?.Description}
                          onClick={(e) => setSelectedGrade(e.target.value)}
                        >
                          {d?.Description}
                        </option>{" "}
                      </>
                    ))
                  : null}
              </select>
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <select
                value={selectedDivision}
                class="form-select DropNewUI"
                onChange={(e) => setSelectedDivision(decodeURI(e.target.value))}
                aria-label="Default select example"
                placeholder="Select Job Title"
              >
                <option
                  value=""
                  selected
                  onChange={() => setSelectedDivision(null)}
                >
                  Division
                </option>
                {Division
                  ? Division?.map((d, i) => (
                      <>
                        <option
                          value={d.Description}
                          // onClick={(e) => setSelectedDivision(e.target.value)}
                        >
                          {d.Description}
                        </option>{" "}
                      </>
                    ))
                  : null}
              </select>
            </div>

            {/* <div className="col-3">
              <select
                class="form-select"
                onChange={(e) => setSelectedDivision(e.target.value)}
                aria-label="Default select example"
              >
                  <option value={null} selected onClick={() => setResetallData(true)}>
                       Division
                      </option>
                {Division
                  ? Division?.map((d, i) => (
                      <>
                        <option
                          value={d?.Description}
                          onChange={(e) => setSelectedDivision(e.target.value)}
                        >
                          {d?.Description}
                        </option>{" "}
                      </>
                    ))
                  : null}
              </select>
            </div> */}
          </div>
            <button className="red-btn" onClick={() => setResetallData(true)}>
              Reset
            </button>
          {/* <div className="col-md-4 text-end"> */}
            <div>

            {/* &nbsp;&nbsp; */}
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
            </div>
            {/* &nbsp;&nbsp;
          <Link to={"emp_reg"}>
          <button className="dash-btn">
          <MdAssignmentAdd />
          &nbsp;&nbsp;Create
          </button>
          </Link> */}
          {/* </div> */}
        </div>
        <div
          className={
            Open ? "table scroll list-table mt-2 h-auto" : "table scroll list-table mt-2 h-auto"
          } style={{maxHeight:"420px"}}
        >
          {/* <table class="table"> */}
        <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">

           <thead>
            <tr className="bg-gray-200">
                <th className="px-2 py-1 border font-normal">Si No</th>
                <th className="px-2 py-1 border font-normal">Emp Id</th>
                <th className="px-2 py-1 border font-normal">Alternate Id</th>
                <th className="px-2 py-1 border font-normal">Status</th>
                <th className="px-2 py-1 border font-normal">Name</th>
                <th className="px-2 py-1 border font-normal">Job Title</th>
                <th className="px-2 py-1 border font-normal">Division</th>
                <th className="px-2 py-1 border font-normal">Grade</th>
                <th className="px-2 py-1 border font-normal">Gender </th>
                <th className="px-2 py-1 border font-normal">Nationality</th>

                {Open ? (
                  <>
                    <th className="px-2 py-1 border font-normal">Bank Account</th>
                    <th className="px-2 py-1 border font-normal">Bank Name</th>
                    <th className="px-2 py-1 border font-normal">Agent Id</th>
                    <th className="px-2 py-1 border font-normal">Current Address</th>
                    <th className="px-2 py-1 border font-normal">Home Address</th>
                    <th className="px-2 py-1 border font-normal">Home Airport</th>
                    <th className="px-2 py-1 border font-normal">Work Mobile</th>
                    <th className="px-2 py-1 border font-normal">Work Phone</th>
                    <th className="px-2 py-1 border font-normal">Personal Phone</th>
                    <th className="px-2 py-1 border font-normal">Personal Email</th>
                    <th className="px-2 py-1 border font-normal">Passport Number</th>
                    <th className="px-2 py-1 border font-normal">Passport Issue Date</th>
                    <th className="px-2 py-1 border font-normal">Passport Expiry Date</th>
                    <th className="px-2 py-1 border font-normal">Passport Place of Issue</th>
                    <th className="px-2 py-1 border font-normal">Passport Country of Issue</th>
                    <th className="px-2 py-1 border font-normal">Emirates id</th>
                    <th className="px-2 py-1 border font-normal">Expiry Date</th>
                    <th className="px-2 py-1 border font-normal">Visa No</th>
                    <th className="px-2 py-1 border font-normal">Visa Expiry Date</th>
                    <th className="px-2 py-1 border font-normal">Insurance Number</th>
                    <th className="px-2 py-1 border font-normal">Insurance Expiry Date</th>
                    <th className="px-2 py-1 border font-normal">Driving license No</th>
                    <th className="px-2 py-1 border font-normal">Driving license Expiry Date</th>
                    <th className="px-2 py-1 border font-normal">Basic Pay</th>
                    <th className="px-2 py-1 border font-normal">Allowances_OT</th>
                    <th className="px-2 py-1 border font-normal">Allownaces_NOT</th>
                    <th className="px-2 py-1 border font-normal">NormalHRS</th>
                    <th className="px-2 py-1 border font-normal">HourlyWage</th>
                    <th className="px-2 py-1 border font-normal">OTRate</th>
                    <th className="px-2 py-1 border font-normal">SplOtRate</th>
                    <th className="px-2 py-1 border font-normal">Active</th>
                    <th className="px-2 py-1 border font-normal">Memos</th>
                    <th className="px-2 py-1 border font-normal">Notes</th>
                    <th className="px-2 py-1 border font-normal">Salary Ac</th>
                    <th className="px-2 py-1 border font-normal">Advance Ac</th>
                  </>
                ) : null}
                <th className="px-2 py-1 border font-normal">Actions</th>
              </tr>
                </thead>
          <tbody>
              {records
                ? records?.map((d, i) => (
                    // <tr key={i} className="dataTr">
                    <tr key={i} className="">
                       <td className="px-2 py-1 border">{i + 1}</td>
                       <td className="px-2 py-1 border">{d?.EmpId}</td>
                       <td className="px-2 py-1 border">{d?.AlternateID}</td>
                       <td className="px-2 py-1 border">{d?.Status}</td>
                       <td className="px-2 py-1 border">{d?.Name}</td>
                       <td className="px-2 py-1 border">{d?.JobTitle}</td>
                       <td className="px-2 py-1 border">{d?.Division}</td>
                       <td className="px-2 py-1 border">{d?.Grade}</td>
                       <td className="px-2 py-1 border">{d?.Single}</td>
                       <td className="px-2 py-1 border">{d?.Nationality}</td>
                      {Open ? (
                        <>
                           <td className="px-2 py-1 border">{d?.BankAccountNo}</td>
                           <td className="px-2 py-1 border">{d?.BankName}</td>
                           <td className="px-2 py-1 border">{d?.AgentID}</td>
                           <td className="px-2 py-1 border">{d?.CurrentAddress}</td>
                           <td className="px-2 py-1 border">{d?.HomeAddress}</td>
                           <td className="px-2 py-1 border">{d?.HomeAirport}</td>
                           <td className="px-2 py-1 border">{d?.WorkMobile}</td>
                           <td className="px-2 py-1 border">{d?.WorkPhone}</td>
                           <td className="px-2 py-1 border">{d?.PersonalPhone}</td>
                           <td className="px-2 py-1 border">{d?.PersonalEmail}</td>
                           <td className="px-2 py-1 border">{d?.PassportNo}</td>
                           <td className="px-2 py-1 border">{d?.PassportIssueDate}</td>
                           <td className="px-2 py-1 border">{d?.PassportExpiryDate}</td>
                           <td className="px-2 py-1 border">{d?.PassportPlaceofIssue}</td>
                           <td className="px-2 py-1 border">{d?.PassportCountryofIssue}</td>
                           <td className="px-2 py-1 border">{d?.EmiratesId}</td>
                           <td className="px-2 py-1 border">{d?.EmiratesIdExpiryDate}</td>
                           <td className="px-2 py-1 border">{d?.VisaNo}</td>
                           <td className="px-2 py-1 border">{d?.VisaExpiryDate}</td>
                           <td className="px-2 py-1 border">{d?.InsuranceNo}</td>
                           <td className="px-2 py-1 border">{d?.InsuranceExpiryDate}</td>
                           <td className="px-2 py-1 border">{d?.DrivingLicenceNo}</td>
                           <td className="px-2 py-1 border">{d?.DrivingLicenceExpiryDate}</td>
                           <td className="px-2 py-1 border">{d?.BasicPay}</td>
                           <td className="px-2 py-1 border">{d?.Allowances_OT}</td>
                           <td className="px-2 py-1 border">{d?.Allowances_NOT}</td>
                           <td className="px-2 py-1 border">{d?.NormalHrs}</td>
                           <td className="px-2 py-1 border">{d?.HourlyWage}</td>
                           <td className="px-2 py-1 border">{d?.OTrate}</td>
                           <td className="px-2 py-1 border">{d?.SplOtRate}</td>
                           <td className="px-2 py-1 border">{d?.Active}</td>
                           <td className="px-2 py-1 border">{d?.Memos}</td>
                           <td className="px-2 py-1 border">{d?.Notes}</td>
                           <td className="px-2 py-1 border">{d?.SalaryA}</td>
                           <td className="px-2 py-1 border">{d?.AdvanceAc}</td>
                        </>
                      ) : null}
                       <td className="px-2 py-1 border text-center">
                        <button
                          // className="dash-btn"
                                                className="bg-blue-500 px-2 py-1 border rounded-lg text-white font-semibold"

                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          onClick={() => setEmpIdPopup(d)}
                        >
                          <div className="flex items-center justify-center gap-1">

                          <PiGitPullRequestDuotone /> 
                          <span>

                          Apply
                          </span>
                          </div>
                        </button>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
          <LeaveApplicationPopup empPopup={empPopup} />
        </div>
        {records ? (
          <>
            <div className="pagination-div">
              <div className="text-end">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item">
                    {
                      currentPage !== 1 ? (
                    <button class="page-link" href="#" onClick={prePage}>
                      Previous
                    </button>
                      ) : ''
                    }
                    </li>
                    {numbers.map((n, i) => (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                        <button
                          className="page-link"
                          onClick={() => changeCPage(n)}
                          href="#"
                        >
                          {n}
                        </button>
                      </li>
                    ))}

                    <li class="page-item">
                    {
                    currentPage !== numbers[numbers.length - 1] ? (
                      <button class="page-link" href="#" onClick={nextPage}>
                        Next
                      </button>
                    ) : null
                  }
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </>
        ) : null}
        <div className="table-nodata-img mtd">
          {loader ? (
            <>
              {" "}
              <div className="table-nodata-img">
                <div className="center">
                  <p className="text-center pt-5">
                    Please Wait Loading Data... &nbsp;
                    <FallingLines />
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default LeaveApplication;
